import Axios from "axios";
const location = window.location;

const GYAxios = Axios.create({
	baseURL: location.origin,
	timeout: 10000,
});

const requestHandler = (request) => {
	const encoded = window.KC_JWT || localStorage.getItem("KC_JWT");
	request.headers.Authorization = `Bearer ${encoded}`;

	return request;
};

const responseHandler = (response) => {
	return response;
};

const errorHandler = (error) => {
	return Promise.reject(error);
};

GYAxios.interceptors.request.use(
	(request) => requestHandler(request),
	(error) => errorHandler(error)
);

GYAxios.interceptors.response.use(
	(response) => responseHandler(response),
	(error) => errorHandler(error)
);

export default GYAxios;
